import React, {useState, useEffect} from "react";
import {useNavigate, useNavigationType} from "react-router";
import {useSelector, useDispatch} from "react-redux";
import {fetchSummaryReceivableInfo, updateReceivableInfo} from "redux/slices/sales/salesSlice";

import {getToday} from "utils/date";
import {getCommaNumber} from "utils/format";

import Section from "components/ui/Section";



/**
 * [누적 미수금 개요]
 */

export const ReceivableInfo = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const navigationType = useNavigationType();
	const {searchPartner, searchBranch, summaryReceivableInfo} = useSelector(state => state.sales);
	const partnerInfo = useSelector(state => state.partner);
	const today = getToday();

	useEffect(() => {
		const isUpdate = (
			searchPartner != summaryReceivableInfo.searchPartner ||
			searchBranch != summaryReceivableInfo.searchBranch ||
			today != summaryReceivableInfo.searchDate
		);
		if(isUpdate) eventHandler.update();
	}, [searchPartner, searchBranch]);

	const eventHandler = {
		update : () => {
			dispatch(updateReceivableInfo({
				searchPartner : searchPartner,
				searchBranch : searchBranch,
				branchUseYn : partnerInfo.branchUseYn,
				searchDate : today
			}, fetchSummaryReceivableInfo));
		},
		detail : () => {
			const isBranch = (partnerInfo.branchUseYn == "Y" && partnerInfo.seqPartnerBranch == 0);
			if(isBranch) {
				navigate("/sales/branch/receivable");
			} else {
				navigate("/sales/receivable");
			}
		},
		refresh : () => {
			eventHandler.update();
		}
	};

	return (
		<Section
			title="현재 누적 미수금"
			text={getCommaNumber((summaryReceivableInfo.data || {}).receivableAmount) + "원"}
			isLoading={summaryReceivableInfo.isLoading}
			isError={summaryReceivableInfo.isError}
			onClick={(summaryReceivableInfo.isError) ? null : eventHandler.detail}
			onRefresh={eventHandler.refresh}
		/>
	);
};

export default ReceivableInfo;



